"use client";

import { FC } from "react";

import { companies } from "@/util";
import { Card, Particles } from "@/components";
import type { EmblaOptionsType } from "embla-carousel";
import EmblaCarousel from "./ui/marquee";
import { useEffect, useRef } from "react";
import Image from "next/image";
import clsx from "clsx";

export const Hero: FC = () => {
  // return (
  //   <section className="relative h-screen flex items-center justify-center bg-black text-white overflow-hidden">
  //     <Particles />
  //   </section>
  // );

  return (
    <div className="h-screen relative translate-y-1/3 md:translate-y-0 md:top-44 2xl:top-60 overflow-hidden">
      <div className="flex flex-col justify-center items-center text-center">
        <div className="flex items-center gap-3">
          <div className="bg-gradient-to-r from-transparent to-white w-20 md:w-32 h-[2px] rounded-full" />
          <div className="text-xl md:text-2xl italic tracking-tight capitalize">
            hey there!
          </div>
          <div className="bg-gradient-to-r from-white to-transparent w-20 md:w-32 h-[2px] rounded-full" />
        </div>
        <div className="px-1 md:px-0 w-full md:w-10/12 leading-snug font-helvetica lg:leading-normal text-3xl lg:text-5xl mt-3 md:mt-4 relative select-text">
          I’m Mehdi, a fullstack developer from Tehran. I help startups and
          enterprises craft digital products that{" "}
          <span className="font-itc select-text">
            connect ideas with people.
          </span>
        </div>
      </div>
      {/* <div className="pt-8 md:pt-16">
        <EmblaCarousel
          slides={companies}
          options={{
            loop: true,
            dragFree: true,
            align: "start",
            containScroll: false,
          }}
        />
      </div> */}

      {/* <div className="flex whitespace-no-wrap overflow-x-hidden mt-2 md:mt-8 motion-safe:overflow-x-hidden group">
        <div className="relative">
          <ul className="flex animate-marquee motion-safe:animate-marquee group-hover:pause-animation transition-all mt-5">
            {companies.map((name) => (
              <li key={name} className="m-6 md:m-4">
                <img
                  alt="company-img"
                  src={`/companies/${name}.png`}
                  className="w-7 md:w-10 inline grayscale mx-6"
                />
              </li>
            ))}
          </ul>
          <ul className="flex absolute top-0 animate-marquee2 motion-safe:animate-marquee2 group-hover:pause-animation transition-all mt-5">
            {companies.map((name) => (
              <li key={name} className="m-6 md:m-4">
                <img
                  alt="company-img"
                  src={`/companies/${name}.png`}
                  className="w-7 md:w-10 inline grayscale mx-6"
                />
              </li>
            ))}
          </ul>
        </div>
      </div> */}
    </div>
  );
};
